import { motion } from "framer-motion";
import LoopVideo from "@/components/home/LoopVideo";

// HP3-only — "One tree. Decades of research." Beta-T / Hinokitiol story.
// Dark teal editorial panel (left) + hinokitiol loop video (right).
// Copy verbatim from the approved mockup; content reveals bottom-to-top.
const VIDEO =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_76fde4e1-b224-41fa-b1e0-b502822df34b/artifacts/1k08pw48_Hinokitiol.mp4";
const TEAL = "#0C3B3E";

const container = { hidden: {}, show: { transition: { staggerChildren: 0.12, delayChildren: 0.1 } } };
const item = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] } },
};

export const BetaTScienceV3 = () => {
  return (
    <section className="w-full" data-testid="home-betat-science-v3">
      <div className="grid grid-cols-1 lg:grid-cols-2 items-stretch lg:min-h-[800px]">
        {/* Left — teal editorial panel */}
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-100px" }}
          className="order-2 lg:order-1 flex flex-col justify-center px-6 py-16 sm:px-10 lg:px-16 lg:py-24 text-white"
          style={{ backgroundColor: TEAL }}
        >
          <div className="max-w-[520px]">
            <motion.h2
              variants={item}
              className="text-[34px] sm:text-[42px] lg:text-[52px] leading-[1.05] tracking-[-0.02em] font-semibold"
            >
              Hinokitiol. <span className="italic font-normal text-white/90">Decades of research.</span>
            </motion.h2>
            <motion.p
              variants={item}
              className="mt-7 text-[14px] lg:text-[15px] leading-[1.7] text-white/75 max-w-[480px]"
            >
              Hinokitiol — which Riversol formulates as Beta-T — is a natural
              compound found in the oil of the Pacific red cedar, with
              antioxidant, anti-inflammatory and anti-pigmentation properties.
              Dr. Rivers first encountered it through his research at the
              University of British Columbia, and spent years on the formulation
              chemistry needed to keep it stable — which is why you'll rarely
              find it anywhere else.
            </motion.p>
            <motion.div variants={item}>
              <a
                href="https://www.riversol.com/blogs/riversol/the-natural-benefits-of-beta-thujaplicin"
                data-testid="betat-science-cta"
                className="mt-9 inline-flex items-center border border-white/45 text-white px-8 py-3.5 text-[12px] tracking-[0.16em] uppercase font-medium hover:bg-white hover:text-[#0C3B3E] transition-colors"
              >
                Explore the Science
              </a>
            </motion.div>
          </div>
        </motion.div>

        {/* Right — hinokitiol loop video (seamless cross-fade loop, muted). */}
        <div className="order-1 lg:order-2 relative min-h-[320px] lg:min-h-0 overflow-hidden">
          <LoopVideo
            src={VIDEO}
            sources={[{ src: "/media/hinokitiol.webm", type: "video/webm" }]}
            poster="/media/hinokitiol-poster.jpg"
            label="Hinokitiol — Pacific red cedar"
            className="absolute inset-0 w-full h-full"
          />
        </div>
      </div>
    </section>
  );
};

export default BetaTScienceV3;
